"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

"use strict";
var Cookies = require("js-cookie");
var jwtDecode = require("jwt-decode");

var IFlyLogin = function () {
  /**
   *
   * @param {Object} params
   * @param {String} [params.identityHost] the identity server host to authorize with
   * @param {String} [params.clientId] the client ID to authorize as
   * @param {String} [params.clientSecret] the client secret to authorize with
   * @param {String} [params.storeCookies=true] if true, will store the access token and decoded values in a cookie
   * @param {String} [params.cookieName="authorization"] the name of the cookie
   * @param {String} [params.cookieDomain="iflyworld.com"] the domain of the cookie
   * @param {Boolean} [params.shouldRefresh=true] if true, the client will automatically refresh
   */
  function IFlyLogin() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$identityHost = _ref.identityHost,
        identityHost = _ref$identityHost === undefined ? IFlyLogin.defaults.identityHost : _ref$identityHost,
        _ref$clientId = _ref.clientId,
        clientId = _ref$clientId === undefined ? IFlyLogin.defaults.clientId : _ref$clientId,
        clientSecret = _ref.clientSecret,
        _ref$storeCookies = _ref.storeCookies,
        storeCookies = _ref$storeCookies === undefined ? IFlyLogin.defaults.storeCookies : _ref$storeCookies,
        _ref$cookieName = _ref.cookieName,
        cookieName = _ref$cookieName === undefined ? IFlyLogin.defaults.cookieName : _ref$cookieName,
        _ref$cookieDomain = _ref.cookieDomain,
        cookieDomain = _ref$cookieDomain === undefined ? IFlyLogin.defaults.cookieDomain : _ref$cookieDomain,
        _ref$shouldRefresh = _ref.shouldRefresh,
        shouldRefresh = _ref$shouldRefresh === undefined ? true : _ref$shouldRefresh;

    _classCallCheck(this, IFlyLogin);

    this.identityHost = identityHost;
    this.clientId = clientId;
    this.clientSecret = clientSecret || IFlyLogin.secrets[this.identityHost];
    this.storeCookies = storeCookies;
    this.cookieName = cookieName;
    this.cookieDomain = cookieDomain;
    this.shouldRefresh = shouldRefresh;

    this._data = null;
  }

  _createClass(IFlyLogin, [{
    key: "buildResponse",
    value: function buildResponse(xhr) {
      return {
        readyState: xhr.readyState,
        response: xhr.response,
        responseText: xhr.responseText,
        responseType: xhr.responseType,
        responseURL: xhr.responseURL,
        responseXML: xhr.responseXML,
        status: xhr.status,
        statusText: xhr.statusText
      };
    }
  }, {
    key: "removeSession",
    value: function removeSession() {
      this._data = null;
      if (this.storeCookies) {
        Cookies.remove(this.cookieName, { domain: this.cookieDomain, secure: true, samesite: 'strict' });
      }
    }

    /**
     * Get the raw authorization cookie
     */

  }, {
    key: "getCookie",
    value: function getCookie() {
      return Cookies.getJSON(this.cookieName);
    }
  }, {
    key: "getData",
    value: function getData() {
      return this._data || this.getCookie();
    }
  }, {
    key: "getToken",
    value: function getToken() {
      return (this.getData() || {}).jwt;
    }
  }, {
    key: "getDecoded",
    value: function getDecoded() {
      return (this.getData() || {}).decoded;
    }
  }, {
    key: "handleError",
    value: function handleError(xhr) {
      var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { error: "unknown_error" };

      console.log("Handling XHR error.", xhr, error);
      error.response = this.buildResponse(xhr);
      this.removeSession();
      return error;
    }
  }, {
    key: "isLoggedIn",
    value: function isLoggedIn() {
      var exp = (this.getDecoded() || {}).exp;
      return !!(exp && new Date().getTime() > exp);
    }

    /**
     * Log the user out.
     * @param {Object} params
     * @param {String} [params.postLogoutRedirectUri] the URI to redirect to after a successful logout
     */

  }, {
    key: "logout",
    value: function logout() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          postLogoutRedirectUri = _ref2.postLogoutRedirectUri;

      console.log("logout()");
      this.removeSession();

      var queryString = postLogoutRedirectUri ? "post_logout_redirect_uri=" + postLogoutRedirectUri : "";
      window.location = this.identityHost + "/Identity/Account/Logout" + (queryString ? "?" + queryString : "");
    }

    /**
     * Authorizes with Identity Server
     * @param {String} username the username
     * @param {String} password the password
     * @returns {Promise<Object>} A promise to the auth token, in jwt and decoded forms
     */

  }, {
    key: "authenticate",
    value: function authenticate(username, password) {
      console.log("Authentication begins");

      var params = "grant_type=password&client_id=" + this.clientId + "&client_secret=" + this.clientSecret + "&username=" + encodeURIComponent(username) + "&password=" + encodeURIComponent(password) + "&scope=core_api.user+offline_access";

      return this.sendRequest(params);
    }

    /**
     * Refreshes the user's token. This will be called periodically
     * unless the Login instance is instantiated with the parameter
     * shouldRefresh: false
     */

  }, {
    key: "refresh",
    value: function refresh() {
      console.log("refresh begins");

      var refreshToken = (this.getData() || { jwt: jwt }).jwt.refresh_token;

      if (!refreshToken) {
        throw new Error("no refresh token");
      }

      var params = "grant_type=refresh_token&client_id=" + this.clientId + "&client_secret=" + this.clientSecret + "&refresh_token=" + refreshToken;

      return this.sendRequest(params);
    }
  }, {
    key: "sendRequest",
    value: function sendRequest(params) {
      var _this = this;

      var xhr = new XMLHttpRequest();

      return new Promise(function (resolve, reject) {
        xhr.onerror = function (error) {
          reject(_this.handleError(xhr, error));
        };

        xhr.onreadystatechange = function () {
          if (xhr.readyState === XMLHttpRequest.DONE) {
            console.log("XHR complete", xhr);
            if (xhr.responseText) {
              console.log("Handling XHR success.", xhr);
              var _jwt = JSON.parse(xhr.responseText);

              if (_jwt.error) {
                reject(_this.handleError(xhr, _jwt));
              } else {
                var data = _this._data = Object.freeze({
                  jwt: _jwt,
                  decoded: jwtDecode(_jwt.access_token)
                });

                if (_this.storeCookies) {
                  Cookies.set(_this.cookieName, data, {
                    domain: _this.cookieDomain,
                    secure: true,
                    samesite: 'strict'
                  });
                }

                // schedule a refresh
                if (_this.shouldRefresh) {
                  var expiresIn = (data.jwt.expires_in || 1800) - 60;
                  console.log("Scheduling refresh in " + expiresIn);
                  setTimeout(function () {
                    return _this.refresh();
                  }, expiresIn * 1000);
                }

                resolve({ data: data, response: _this.buildResponse(xhr) });
              }
            } else {
              reject(_this.handleError(xhr));
            }
          }
        };

        xhr.open("POST", _this.identityHost + "/connect/token", true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.send(params);
        console.log("XHR sent.");
      });
    }
  }]);

  return IFlyLogin;
}();

module.exports = {
  IFlyLogin: IFlyLogin
};

IFlyLogin.defaults = Object.freeze({
  identityHost: "https://stg-login.iflyworld.com",
  clientId: "iFlyCustomerPortal",
  clientSecret: "dAP3D5ackY4eMLiRyXME7qZLx",
  storeCookies: true,
  cookieName: "authorization",
  cookieDomain: "iflyworld.com"
});

IFlyLogin.secrets = {
  "https://local-login.iflyworld.com": "dAP3D5ackY4eMLiRyXME7qZLx",
  "https://dev-login.iflyworld.com": "dAP3D5ackY4eMLiRyXME7qZLx",
  "https://stg-login.iflyworld.com": "dAP3D5ackY4eMLiRyXME7qZLx",
  "https://login.iflyworld.com": "qN5Jg7ebXRwngQ3NxACUt4vs2"
};